// extracted by mini-css-extract-plugin
module.exports = {"prettyModal":"CustomModal_prettyModal__ez6B0"};